/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidActivatePathParams,
  PostApiV1IndividualpaymentParcelsParcelidActivate400,
  PostApiV1IndividualpaymentParcelsParcelidActivate401,
  PostApiV1IndividualpaymentParcelsParcelidActivate500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidActivate.ts";

function getPostApiV1IndividualpaymentParcelsParcelidActivateUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/activate` as const,
  };
  return res;
}

/**
 * @description Apenas parcelas canceladas podem ser reativadas. Migrado do legado IndividualPayment/ActivateParcel. **(Requer Authorization para autenticação)**
 * @summary Reativa uma parcela cancelada (volta a pendente) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/activate}
 */
export async function postApiV1IndividualpaymentParcelsParcelidActivate(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidActivatePathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidActivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidActivate400
      | PostApiV1IndividualpaymentParcelsParcelidActivate401
      | PostApiV1IndividualpaymentParcelsParcelidActivate500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidActivateUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
